import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

/** What the user chose when asked about unsaved changes. Closing the dialog any other way counts as `stay`. */
export type UnsavedChangesChoice = 'save' | 'discard' | 'stay';

/**
 * Asks what to do with the unsaved changes on a request form the user is about to leave:
 * save them as a draft, throw them away, or stay on the form.
 * The dialog closes with an {@link UnsavedChangesChoice}.
 */
@Component({
    selector: 'xp-unsaved-changes-dialog',
    standalone: true,
    imports: [MatButtonModule, MatDialogModule],
    template: `
        <h2 mat-dialog-title>Unsaved changes</h2>
        <mat-dialog-content>
            This request has changes that have not been saved. What would you like to do?
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-button type="button" mat-dialog-close="stay">Stay</button>
            <button mat-button type="button" color="warn" mat-dialog-close="discard">Discard</button>
            <button mat-raised-button type="button" color="accent" cdkFocusInitial mat-dialog-close="save">Save as Draft</button>
        </mat-dialog-actions>
    `
})
export class UnsavedChangesDialogComponent {
}
